import { render, staticRenderFns } from "./GEMS.vue?vue&type=template&id=fcf0a540&"
import script from "./GEMS.vue?vue&type=script&lang=js&"
export * from "./GEMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports